import { GET_ALL_MEDICAL_FILES_IN_A_DOCUMENT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface AllMedicalFiles {
    patient_name: string;
    document_type: string;
    document_date: string;
    files?: FilesEntity[] | null;
    smart_report?: SmartReport;
    document_id?: string;
    notes_response?: {
        notes?: Notes[];
        next_token?: string;
    };
}

export type NotesResponse = {
    notes?: Notes[];
    next_token?: string;
};

export type Notes = {
    id: string;
    author: string;
    time: number;
    text: string;
};

export interface SmartReport {
    verified?: VerifiedEntity[] | null;
    unverified: VerifiedEntity[] | null;
}

export interface VerifiedEntity {
    name: string;
    value: string;
    range: string;
    /**
     * @deprecated
     */
    result: string;
    result_id: string;
    display_result: string;
    id: number;
    page_num: number;
    file_index: number;
    coordinates?: CoordinatesEntity[] | null;
    eka_id?: string | null;
    is_result_editable: boolean;
    date: number;
    unit?: string | null;
    unit_eka_id?: string | null;
}

export interface CoordinatesEntity {
    x: number;
    y: number;
}

export interface FilesEntity {
    asset_url: string;
    file_type: string;
}

export default (ptId: string, docId: string, vitalId?: string): Promise<AllMedicalFiles> => {
    return fetchWithRefresh(GET_ALL_MEDICAL_FILES_IN_A_DOCUMENT(ptId, docId, vitalId)).then(
        (res) => {
            if (res.status === 200) {
                return res.json();
            } else {
                throw new Error('GET_ALL_MEDICAL_FILES_IN_A_DOCUMENT failed');
            }
        },
    );
};
